import { render, staticRenderFns } from "./ResourceDetailInputField.vue?vue&type=template&id=d3e83fce"
import script from "./ResourceDetailInputField.vue?vue&type=script&lang=js"
export * from "./ResourceDetailInputField.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetailInputField.vue?vue&type=style&index=0&id=d3e83fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports